import { useTranslation } from 'react-i18next';

export const useMultilingualArray = (tKey, area, separator = '&split&'): string[] => {
  const { t } = useTranslation(area);
  const value = t(tKey);
  return value.split(separator);
};
